import React, { useState } from "react";
import { X } from "lucide-react";
import useCreateAdmin from "../../hooks/useCreateAdmin";
import { toast } from 'react-hot-toast';

export const AddMemberModal = ({ show, onClose, currentGroupId, onAdd }) => {
  const [form, setForm] = useState({});
  const { createAdmin, isLoading, error } = useCreateAdmin();

  if (!show) return null;

  const handleAdd = async () => {
    if (!form.name || !form.phone || !form.email || !form.password) return;

    const payload = {
      ...form,
      group_id: form.group_id || currentGroupId,
      admin_role_id: Number(localStorage.getItem("role_id")),
    };

    try {
      const response = await createAdmin(payload);
      if (response.success) {
        toast.success(response.message || "Member added successfully");
      } else {
        toast.error(response.message || "Failed to create admin");
      }

      if (onAdd) {
        const newAdmin = {
          id: Date.now(),
          name: form.name,
          phone: form.phone,
          email: form.email,
          group_id: payload.group_id,
          role_id: payload.role_id,
        };
        onAdd(newAdmin);
      }

      setForm({});
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>

        <h2 className="text-xl sm:text-2xl font-semibold mb-5 text-gray-900">
          Add New Member
        </h2>

        <div className="flex flex-col gap-4">
          <input
            type="text"
            placeholder="Name"
            value={form.name || ""}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none placeholder-gray-400"
          />
          <input
            type="text"
            placeholder="Phone"
            value={form.phone || ""}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none placeholder-gray-400"
          />
          <input
            type="email"
            placeholder="Email"
            value={form.email || ""}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none placeholder-gray-400"
          />
          <input
            type="password"
            placeholder="Password"
            value={form.password || ""}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none placeholder-gray-400"
          />
          {currentGroupId === "1" && (
            <input
              type="text"
              placeholder="Group ID"
              value={form.group_id || ""}
              onChange={(e) => setForm({ ...form, group_id: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none placeholder-gray-400"
            />
          )}
          <input
            type="number"
            placeholder="Role ID"
            value={form.role_id || ""}
            onChange={(e) =>
              setForm({ ...form, role_id: parseInt(e.target.value) })
            }
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none placeholder-gray-400"
          />

          {error && <p className="text-red-500 text-sm">{error}</p>}

          <button
            onClick={handleAdd}
            disabled={isLoading}
            className={`w-full py-2 mt-3 rounded-lg font-semibold text-white transition-colors duration-200 ${
              isLoading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"
            }`}
          >
            {isLoading ? "Adding..." : "Add Member"}
          </button>
        </div>
      </div>
    </div>
  );
};
